import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import { FormControlService } from '@zipari/design-system';
import {
  controlTypes,
  formControlDirections,
} from '@zipari/shared-ds-util-form';
import { isInEnum } from '@zipari/web-utils';
import { customFormElements } from '../custom-form-element/custom-form-element.constants';
import { StepperPrefillVal } from '../layouts/layout-templates/layout-desktop-stepper-forms/layout-desktop-stepper-forms.constants';

@Component({
  selector: 'form-group',
  templateUrl: './form-group.component.html',
  styleUrls: ['./form-group.component.scss'],
})
export class FormGroupComponent implements OnInit {
  @Output() formCreated = new EventEmitter<any>();
  @Output() inputChanged = new EventEmitter<any>();
  @Output() linkClicked = new EventEmitter<any>();
  @Output() iconClicked = new EventEmitter<any>();
  @Output() selected = new EventEmitter<any>();

  @Input() prefillVal: StepperPrefillVal = {};
  @Input() context: Record<string, unknown> = {};
  @Input() configs: Array<any>;
  @Input() form: UntypedFormGroup = new FormGroup({});

  constructor(
    public cdr: ChangeDetectorRef,
    public formControlService: FormControlService,
  ) {}

  _direction;

  public get direction() {
    return this._direction;
  }

  @Input('direction')
  public set direction(direction) {
    if (isInEnum(formControlDirections, direction)) {
      this._direction = direction;
    }
  }

  ngOnInit() {
    if (!this.configs) {
      throw new Error('You must provide a config');
    }

    this.configs.forEach((controlConfig) => {
      if (isInEnum(controlTypes, controlConfig.type)) {
        // The "onlyIf" config here is used by at least shopping for a dynamic form
        if (!controlConfig.onlyIf) {
          this.formControlService.addControlToFormGroup(
            this.form,
            controlConfig,
            this.context,
          );
        }

        controlConfig.customFormElement = false;
      } else {
        if (controlConfig.type === 'whoseCovered') {
          this.formControlService.addFormGroupToFormGroup(
            this.form,
            controlConfig,
            this.context,
          );
        }

        if (controlConfig.type === 'coverageEffective') {
          this.formControlService.addControlToFormGroup(
            this.form,
            controlConfig,
            this.context,
          );
        }

        controlConfig.customFormElement = true;
      }
    });

    this.formCreated.emit();
  }

  handleFormCreated(event, config) {
    if (
      config.type === customFormElements.whoseCovered &&
      this.context[config.prop]
    ) {
      this.form.get(config.prop).patchValue(this.context[config.prop]);

      const subscriber = this.form.get('whoseCovered.subscriber');
      subscriber.patchValue(this.context.subscriber);

      const spouse = this.form.get('whoseCovered.spouse');
      if (spouse) {
        spouse.patchValue(this.context.spouse);
      }

      const deps = this.form.get('whoseCovered.dependents');
      if (deps) {
        (this.context.dependents as any[]).forEach((depControl, ind) => {
          deps[ind].patchValue(this.context.dependents[ind]);
        });
      }

      this.form.get(config.prop).patchValue(this.context[config.prop]);
    }

    this.formCreated.emit(event);
  }

  public updateOptions(prop: string, options: any) {
    this.configs = this.configs.map((config) => {
      if (config.prop === prop) {
        return {
          ...config,
          options,
        };
      }

      return config;
    });

    this.cdr.detectChanges();
  }
}
